import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import useTranslation from '@hooks/useTranslation';

import type { IReplaceParts } from '@model/aiReport';

import TextFieldComponent from '../TextFieldComponent/TextFieldComponent';
import style from './style.module.scss';

interface IProps {
  replacedParts: IReplaceParts[];
}

const ReplacedPartsComponent: React.FC<IProps> = ({ replacedParts = [] }) => {
  const { t } = useTranslation();

  if (!replacedParts?.length) {
    return null;
  }

  return (
    <div className={style.replacedPartsBlock}>
      <div className={style.replacedPartsTitle}>{t('Replacement Information')}</div>
      <table className={style.replacedPartsTable} cellSpacing="0" cellPadding="0">
        <thead className={style.replacedPartsTableHead}>
          <tr>
            <th className={style.replacedPartsTableTh}>{t('name of oem')}</th>
            <th className={style.replacedPartsTableTh}>{t('part number')}</th>
            <th className={style.replacedPartsTableTh}>{t('supplier part number')}</th>
          </tr>
        </thead>
        <tbody className={style.replacedPartsTableBody}>
          {replacedParts.map((part) => (
            <tr key={uuidv4()} className={style.replacedPartsTableBodyRow}>
              <td className={style.replacedPartsTableTd}>
                <div className={style.tableField} data-qa={'name-of-oem'}>
                  {part.nameOfOem}
                </div>
              </td>
              <td className={style.replacedPartsTableTd}>
                <div className={style.tableField} data-qa={'part-number'}>
                  {part.amazonPart}
                </div>
              </td>
              <td className={style.replacedPartsTableTd}>
                <div className={style.tableField} data-qa={'supplier-part-number'}>
                  {part.amazonEamPart}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReplacedPartsComponent;
